"use strict";exports.__esModule = true;function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var DrawingTool = function () {


  function DrawingTool(context) {_classCallCheck(this, DrawingTool);this.


























    touchstart = this.mousedown;this.
    touchmove = this.mousemove;this.
    touchend = this.mouseup;this.context = context;this.started = false;}DrawingTool.prototype.mousedown = function mousedown(event) {DrawingTool.coordinates = [];this.context.beginPath();this.context.moveTo(event._x, event._y);this.started = true;};DrawingTool.prototype.mousemove = function mousemove(event) {if (this.started) {this.context.lineTo(event._x, event._y);DrawingTool.coordinates.push([event._x + event.target.offsetLeft, event._y]);this.context.stroke();}};DrawingTool.prototype.mouseup = function mouseup(event) {if (this.started) {this.mousemove(event);this.started = false;}};return DrawingTool;}();DrawingTool.coordinates = [];exports.default = DrawingTool;module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/DrawingOverlay/DrawingTool.js
// module id = 2641
// module chunks = 0